import { CellInputType, CellProps } from '../../../../../components'
import { useConf, useIsMobile } from '../../../../../contexts'
import { BASIC_DATE_FORMAT } from '../../../../../utils'
import { EmploymentData } from '../types'

export const useEmploymentKeysAndColumns = (): CellProps<EmploymentData>[] => {
  const config = useConf()

  const isMobile = useIsMobile()

  const { isNewWorkplaceEditable, isOldWorkplaceEditable } =
    config.baseDetails.employments.employmentInfo

  const employerLabelTranslationId =
    'pages.ownInfoPage.employment.employments.employer'
  const workplaceLabelTranslationId =
    'pages.ownInfoPage.employment.employments.workplace'
  const paymentMethodTypeLabelTranslationId =
    'pages.ownInfoPage.employment.employments.paymentMethod.type.label'

  return [
    {
      key: 'taNimi',
      columnWidth: '20%',
      labelTranslationId: employerLabelTranslationId,
      inputTypeProps: {
        type: CellInputType.Text,
        inputProps: {
          placeholderTranslationId: employerLabelTranslationId
        },
        showOnlyForNewItem: true
      }
    },
    {
      key: 'tpNimi',
      columnWidth: '20%',
      labelTranslationId: workplaceLabelTranslationId,
      inputTypeProps: {
        type: CellInputType.ComboBox,
        inputProps: {
          placeholderTranslationId: workplaceLabelTranslationId
        },
        showTextFieldIfNoData: true,
        isEditingDisabledForNewItem: isNewWorkplaceEditable !== true,
        isEditingDisabledForOldItem: isOldWorkplaceEditable !== true
      }
    },
    {
      key: 'paatoiminenText',
      columnWidth: '10%',
      labelTranslationId: 'pages.ownInfoPage.employment.employments.type.label',
      inputTypeProps: {
        type: CellInputType.CheckBox,
        inputKey: 'paatoiminen',
        inputProps: {
          labelTranslationId:
            'pages.ownInfoPage.employment.employments.type.types.fullTime'
        },
        showOnlyForNewItem: true
      }
    },
    {
      key: 'alkupvm',
      columnWidth: '15%',
      displayWhenNull: '-',
      labelTranslationId:
        'pages.ownInfoPage.employment.employments.startDate.text',
      dateFormat: BASIC_DATE_FORMAT,
      inputTypeProps: { type: CellInputType.Date, showOnlyForNewItem: true }
    },
    {
      key: 'loppupvm',
      columnWidth: '15%',
      labelTranslationId:
        'pages.ownInfoPage.employment.employments.endDate.text',
      dateFormat: BASIC_DATE_FORMAT,
      inputTypeProps: {
        type: CellInputType.Date
      }
    },
    {
      key: 'taPerintaText',
      labelTranslationId: isMobile
        ? paymentMethodTypeLabelTranslationId
        : 'pages.ownInfoPage.employment.employments.paymentMethod.label',
      inputTypeProps: {
        type: CellInputType.ComboBox,
        inputKey: 'taPerinta',
        inputProps: {
          placeholderTranslationId: paymentMethodTypeLabelTranslationId
        },
        showOnlyForNewItem: true
      }
    }
  ]
}
